export const dimension = new Map([
	[0, { name: '时间', column: 'dt' }],
	[1, { name: '国家', column: 'region' }],
	[2, { name: '产品负责人', column: 'principalUser' }],
	[3, { name: '项目组', column: 'productGroupName' }],
	[4, { name: '产品组', column: 'groupName' }],
]);
